/**
 * Exports data to a CSV file and triggers a download
 * @param data The data to export
 * @param filename The name of the file to download (without extension)
 */
export const exportToCSV = (data: any[], filename: string) => {
  if (!data || !data.length) {
    console.warn('No data to export');
    return;
  }

  // Get headers from the first item
  const headers = Object.keys(data[0]);
  
  // Create CSV content
  const csvContent = [
    // Add headers row
    headers.join(','),
    // Add data rows
    ...data.map(item => 
      headers.map(header => {
        // Handle values that might contain commas by wrapping in quotes
        const value = item[header]?.toString() || '';
        return value.includes(',') ? `"${value}"` : value;
      }).join(',')
    )
  ].join('\n');

  // Create a blob and download link
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  
  // Set up and trigger the download
  link.setAttribute('href', url);
  link.setAttribute('download', `${filename}.csv`);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}; 